const o = "fr";
export {
  o as DEFAULT_COUNTRY
};
